import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";
import { IBoxContactErpMessages } from "./BoxContactFormERP.types";
import * as yup from "yup";
export const IBoxContactErpMessagesScheme = z.object({
  contact_erp_name_surname_placeholder:
    themeScheme.MessageScheme.default("Imię i nazwisko"),
  contact_erp_name_surname_validation_error: themeScheme.MessageScheme.default(
    "Imię musi mieć minimum 3 znaki, maksymalnie 50"
  ),
  contact_erp_email_placeholder: themeScheme.MessageScheme.default("E-mail"),
  contact_erp_email_validation_error: themeScheme.MessageScheme.default(
    "Błędny format adresu E-mail"
  ),
  contact_erp_phone_number_placeholder:
    themeScheme.MessageScheme.default("Nr telefonu"),
  contact_erp_phone_number_validation_error: themeScheme.MessageScheme.default(
    "Numer telefonu musi zawierać 9 cyfr"
  ),
  contact_erp_button_text: themeScheme.MessageScheme.default("Wyślij"),
});

export const IBoxContactErpSettingsScheme = z.object({
  contact_erp__input: themeScheme.InputIdScheme.default("input$$1"),
  contact_erp_button_style: themeScheme.ButtonIdScheme.default("button$$1"),
  contact_erp_redirect_successful_send_form:
    themeScheme.UrlScheme.default("/success-sent-erp-account").catch("/success-sent-erp-account"),
  no_data_redirect_url: themeScheme.UrlScheme.default("/join-the-customers").catch("/join-the-customers"),
});

export const getContactErpSchema = (messages: IBoxContactErpMessages) => {
  return yup.object().shape({
    contactPerson: yup.string()
      .required(messages.contact_erp_name_surname_validation_error)
      .min(3, messages.contact_erp_name_surname_validation_error)
      .max(50, messages.contact_erp_name_surname_validation_error),
    email: yup.string()
      .required(messages.contact_erp_email_validation_error)
      .email(messages.contact_erp_email_validation_error),
    phoneNumber: yup.string()
      .required(messages.contact_erp_phone_number_validation_error)
      .matches(/^\d{3}-\d{3}-\d{3}$/, messages.contact_erp_phone_number_validation_error),
  });
};